import { useState, useEffect, useCallback, useContext } from "react";
import { Modal, Button, Spinner, Form } from "react-bootstrap";
import { useAuthStatus } from "../../context/AuthContext";
import { MapContext } from "../../context/MapContext";
import { SEARCH_DATA } from "../../constants/Constant";
import { toHalfWidth } from "../../utils/Util";

const ChibanSearchModal = ({
  show,
  handleClose,
  showLoginPrompt,
  showNiniModal,
}) => {
  const { isUserLoggedIn } = useAuthStatus();
  const { map } = useContext(MapContext);

  const [isLoading, setIsLoading] = useState(false);
  const [pankuzu, setPankuzu] = useState([]);
  const [masterResult, setMasterResult] = useState([]);
  const [isChibanList, setIsChibanList] = useState(false);
  const [query, setQuery] = useState("");

  const fetchData = useCallback(
    async (code) => {
      // スピナー表示
      setIsLoading(true);
      setQuery("");
      try {
        let tmpcode = code;
        if (code.length >= 5) {
          tmpcode = `${code.substr(0, 5)}/${code}`;
        }
        const response = await fetch(`${SEARCH_DATA}${tmpcode}.json`);
        const data = await response.json();

        setMasterResult(data);
        const isChiban = code.length === 17; // true:リンク先が地番、false:リンク先が行政・町字
        setIsChibanList(isChiban);

        if (!isChiban && data.length === 1 && data[0].chimei === "") {
          //１件しかないかつchimeiが空文字の場合は、自動的に下の階層にはいる
          fetchData(data[0].code1);
        }
      } catch (error) {
        console.error("地番データの取得に失敗しました:", error);
        setMasterResult([]);
      } finally {
        // スピナー非表示
        setIsLoading(false);
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [SEARCH_DATA]
  );

  // モーダル表示時の初期化処理
  useEffect(() => {
    if (show && pankuzu.length === 0) {
      fetchData("0");
      setPankuzu([{ code: "0", name: "全国" }]);
    }
  }, [show, pankuzu, fetchData]);

  // パンくずリストクリック
  const handlePankuzuClick = (code, index) => {
    setPankuzu(pankuzu.slice(0, index + 1));
    fetchData(code);
  };

  // 行政・町字リンククリック
  const handleCityClick = (code, name, x, y) => {
    if (map) {
      map.panTo([x, y]);
    }
    setPankuzu([...pankuzu, { code, name: name || "（地番指定）" }]);
    fetchData(code);
  };

  // 地番リンククリック
  const handleLotNoClick = (file, x, y, flag) => {
    if (!isUserLoggedIn) {
      showLoginPrompt();
      return;
    }

    if (flag === 0) {
      // 公共座標
      if (map) {
        if (map.getZoom() < 18) {
          map.setZoom(18);
        }
        map.panTo([x, y]);
      }
    } else {
      // 任意座標
      showNiniModal([{ FileNameELEM: file, L_File_SIF_OAZA: [] }], x, y);
    }
    handleClose();
  };

  const filteredResult = masterResult.filter((elem) => {
    const halfWidthQuery = toHalfWidth(query);
    if (isChibanList) {
      return elem.lot.startsWith(halfWidthQuery);
    } else {
      return elem.chimei.includes(halfWidthQuery);
    }
  });

  return (
    <Modal show={show} onHide={handleClose} size="xl">
      <Modal.Header closeButton>
        <div className="d-flex flex-wrap">
          {pankuzu.map((item, index) => (
            <Button
              key={item.code}
              variant="outline-primary"
              className="pankuzu my-1"
              onClick={() => handlePankuzuClick(item.code, index)}
            >
              {item.name}
            </Button>
          ))}
        </div>
      </Modal.Header>
      <Modal.Body style={{ minHeight: "300px" }}>
        {isLoading ? (
          <div className="d-flex justify-content-center align-items-center h-100">
            <Spinner animation="border" role="status">
              <span className="visually-hidden">Loading...</span>
            </Spinner>
          </div>
        ) : (
          <>
            {!isUserLoggedIn ? <p>地番検索にはログインが必要です。</p> : null}
            <Form.Control
              style={{ width: "300px" }}
              type="text"
              placeholder="絞り込み"
              value={query}
              onChange={(e) => setQuery(e.target.value)}
            />
            <div className="mt-2">
              {filteredResult.map((item, i) =>
                isChibanList ? (
                  <Button
                    key={i}
                    variant="link"
                    onClick={() =>
                      handleLotNoClick(item.file, item.x, item.y, item.flag)
                    }
                  >
                    {item.lot}
                  </Button>
                ) : (
                  <Button
                    key={item.code1}
                    variant="link"
                    onClick={() =>
                      handleCityClick(item.code1, item.chimei, item.x, item.y)
                    }
                  >
                    {item.chimei || "（地番指定）"}
                  </Button>
                )
              )}
            </div>
          </>
        )}
      </Modal.Body>
      <Modal.Footer className="px-3">
        <div style={{ marginRight: "auto" }}>
          <p style={{ fontSize: "small" }}>
            都市部や住宅地に多い住居表示実施エリアなどでは、日常で使われている住所と地番（底地番）が異なることがあります。
          </p>
        </div>
        <Button variant="primary" className="w-100" onClick={handleClose}>
          閉じる
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ChibanSearchModal;
